import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Roles() {
  const { lang, t } = useLang();
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/roles?lang=${lang}`).then((r) => setItems(r.data.items || []));
  }, [lang]);
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold flex items-center gap-2">
          <Users className="w-6 h-6 text-[#C85A32]" /> {t("roles.title")}
        </h1>
        <p className="text-[#4A525A] mt-1">{t("roles.subtitle")}</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {items.map((r) => (
          <div
            key={r.role}
            data-testid={`role-${r.role.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="bg-white border-2 border-[#E4DDD3] rounded-2xl p-5"
          >
            <div className="text-lg font-bold text-[#1C2024]">{r.role}</div>
            <div className="text-[#4A525A] mt-2">{r.plain}</div>
            <div className="mt-3 border-l-2 border-[#C85A32]/40 pl-3 text-sm text-[#1C2024]">
              <span className="font-semibold">{t("roles.tip")} </span>
              {r.tips}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
